import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { FilterProvider } from './context/FilterContext';
import Layout from './layouts/Layout';
import Dashboard from './pages/Dashboard';
import Players from './pages/Players';
import PlayerProfile from './pages/PlayerProfile';
import Leagues from './pages/Leagues';
import LeagueDetail from './pages/LeagueDetail';
import Search from './pages/Search';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminHome from './pages/AdminHome';
import AdminProfileModeration from './pages/AdminProfileModeration';
import AdminPlayerProfiles from './pages/AdminPlayerProfiles';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <FilterProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/players" element={<Players />} />
            <Route path="/players/:id" element={<PlayerProfile />} />
            <Route path="/leagues" element={<Leagues />} />
            <Route path="/leagues/:id" element={<LeagueDetail />} />
            <Route path="/search" element={<Search />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/profile-moderation" element={<AdminProfileModeration />} />
            <Route path="/admin/player-profiles" element={<AdminPlayerProfiles />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </FilterProvider>
  );
}
